import AbstractListenerAction from "~/ts/library/listen/AbstractListenerAction";
import {OperatorApplicationEventManager} from "~/operatorApplication/ts/OperatorApplicationEventManager";

export default class SnippetListener extends AbstractListenerAction {
    public getAction(): string {
        return "snippet";
    }

    public onAction(payload: CometOperatorApplication.SnippetCometMessageOpenApiModel): void {
        OperatorApplicationEventManager.emit(payload.id, payload)
    }
}


/*
{"id":1,"channel":"14755221258159fdb93bdc95487328cc4cc83208","text":{"action":"editMessage","id":184744097,"text":"в пердакшен!"},"time":"1561049769050","tag":0}
 */